@if (!isLoading) {
  <div
    class="component-container"
    [ngStyle]="{
      '--color50': booking?.seminar?.category?.color50,
      '--color0': booking?.seminar?.category?.color0,
      '--color70': booking?.seminar?.category?.color70,
      '--color80': booking?.seminar?.category?.color80,
      '--color90': booking?.seminar?.category?.color90,
    }">
    <div class="page-navigation">
      <div class="circle-large" (click)="onGoBack()">
        <div class="circle-icon">
          <i class="fa-regular fa-arrow-left fa-xl"></i>
        </div>
      </div>
    </div>
    <app-booking-details
      class="padding-bottom-48"
      [booking]="booking"></app-booking-details>
  </div>
  @if (booking.status !== 'waitlist') {
    <div class="sticky-container-bottom">
      <button
        type="button"
        class="inwi-icon-text-button-large-secondary"
        (click)="onDownloadInvoice()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-arrow-down-to-line"></i>
          </div>
          <div class="button-text">Rechnung Herunterladen</div>
        </div>
      </button>
    </div>
  }
} @else {
  <div class="main-container">
    <div class="main-content">
      <div class="loading-wrapper">
        <mat-progress-spinner
          color="primary"
          mode="indeterminate"
          diameter="100">
        </mat-progress-spinner>
      </div>
    </div>
  </div>
}
